import { RCTHeader, RCTTitleContainer } from './RCTProductsHeader.styles';
import Heading from '@legacy-vfuk/core-heading';
import Button from '@legacy-vfuk/core-button';
import Toggle from '@legacy-vfuk/core-toggle';
import { ProductBundle } from '@/types/Product.types';
import { RCTProductRow } from './RCTProductRow';
import { handleScrollToSection } from '@/helpers/GlobalEvents';
import handleTranslation from '@/helpers/handleTranslation';

export const RCTProductsHeader = ({
  products,
  isExpanded,
  setIsExpanded,
}: {
  products: ProductBundle[];
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
}) => {
  const defaultTypename = ['ContentfulSectionCardDisplay', 'ContentfulSectionSwPricingContent', 'SWSectionTariffCards'];

  const ExpandAll = handleTranslation('Expand all','Expandir todos');
  const compareProducts = handleTranslation('Compare Products','Compare as licenças');

  return (
    <RCTHeader productCount={products.length}>
      <RCTTitleContainer>
        <Heading level={4} text={compareProducts} />
        <Button text="Buy" width="full" onClick={() => handleScrollToSection(defaultTypename)} />

        <Toggle
          isActive={isExpanded}
          onChange={() => setIsExpanded(!isExpanded)}
          name="expand-all-toggle"
          id="expand-all-toggle"
          value="expand-all-toggle"
          showIcons={false}
          align="left"
        >
          <span id="rtc-expand-all-desktop">{ExpandAll}</span>
        </Toggle>
        <span id="rtc-expand-all-mobile">{ExpandAll}</span>
      </RCTTitleContainer>
      {products.map(product => (
        <RCTProductRow key={product.id || product.name} product={product} />
      ))}
    </RCTHeader>
  );
};
